import React from "react";
import LogoImg from "../../assets/MWLogoWhite.png";
import imgLogo from "../../assets/mwa/mwlogo.png"
import styled from "@emotion/styled";

interface Props {
  logoSize?: any;
  hideLogo?: any;
  size?: any;
  logo?: any;
}

const BrandLogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-left: 12%;
  margin-top: 0%
`;

const LogoImage = styled.div<Props>`
  width: ${({ size }: any) => (size ? size + "px" : "")};
  height: ${({ size }: any) => (size ? size + "px" : "auto")}; /* Set height to auto */
  max-width: 100%; /* Ensure image doesn't exceed parent's width */
  max-height: 100%; /* Ensure image doesn't exceed parent's height */
  overflow: hidden; /* Hide any part of the image that exceeds the dimensions */
  
  img {
    width: 100%; /* Ensure the image fills the container */
    height: 100%; /* Ensure the image fills the container */
    object-fit: contain; /* Maintain aspect ratio and fit the entire image within the container */
  }
`;



export function BrandLogo(props: Props) {
  const { logoSize, hideLogo, logo } = props;

  return (
    <BrandLogoContainer>
      {hideLogo && (
          <LogoImage size={logoSize}>
            <img src={logo ? logo : LogoImg} alt="MW" />
          </LogoImage>
      )}
      {!hideLogo && (
          <LogoImage size={logoSize}>
            <img src={imgLogo} alt="MW" />
          </LogoImage>
      )}
      {/* <LogoTitle size={textSize} color={color}>
        Malthe Winje
      </LogoTitle> */}
    </BrandLogoContainer>
  );
} 